import { render, staticRenderFns } from "./ObservationNew.vue?vue&type=template&id=bc1f446a&scoped=true&"
import script from "./ObservationNew.vue?vue&type=script&lang=js&"
export * from "./ObservationNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1f446a",
  null
  
)

export default component.exports